export default "__VITE_ASSET__DQ40sYRf__"